    import apiClient from './config';
import { CAREERINFO_ENDPOINTS } from './endpoints';

const careerinfoService = {
  career_info: (data) => {
    return apiClient.get(CAREERINFO_ENDPOINTS.CAREER_INFO, data);
  },
  feature_info: (data) => {
    return apiClient.get(CAREERINFO_ENDPOINTS.FEATURE_INFO, data);
  },
  benefit_info: (data) => {
    return apiClient.get(CAREERINFO_ENDPOINTS.BENEFIT_INFO, data);
  },
};

export default careerinfoService;
